import GambitService from 'services/GambitService';

export default {
  install(Vue) {
    Vue.prototype.$gambit = GambitService;
  },
};
